// src/pages/PublicProfile/PublicProfileWrapper.js
import React, { useContext } from 'react';
import PublicProfile from './PublicProfile';
import { AuthContext } from '../../context/AuthContext';

const PublicProfileWrapper = () => {
  const { currentUser } = useContext(AuthContext);

  const defaultUserId = currentUser?._id || currentUser?.id || '';
  const defaultUsername = currentUser ? currentUser.username : 'ques';

  return <PublicProfile defaultUserId={defaultUserId} defaultUsername={defaultUsername} />;
};

export default PublicProfileWrapper;
